// Cloudflare Web Analytics: cookieless, no personal data, no consent banner.
// Records page paths (never query strings), referrers, devices and page speed.
// Loaded only in production builds, and only when a site token is configured.

export function startAnalytics() {
  const token = import.meta.env.VITE_CF_ANALYTICS_TOKEN;
  if (import.meta.env.DEV || !token) return;
  const script = document.createElement('script');
  script.defer = true;
  script.src = 'https://static.cloudflareinsights.com/beacon.min.js';
  // spa: count in-app navigation (React Router) as page views, not just the first load.
  script.dataset.cfBeacon = JSON.stringify({ token, spa: true });
  document.head.appendChild(script);
}
